(function() {
  exports.StepFunctions = (function() {
    function StepFunctions() {}

    StepFunctions.prototype.testFunc = function() {
      var step;
      step = this;
      return true;
    };

    StepFunctions.prototype.addExpectedYieldValidation = function() {
      var step;
      step = this;
      step.getInputEl().addClass('validate-in-range').attr('data-min', 0).attr('data-max', 500);
      return true;
    };

    StepFunctions.prototype.addMaturityValidation = function() {
      var maxMaturity, maxMaturityID, minMaturity, minMaturityID, step;
      step = this;
      step.getInputEl().addClass('validate-in-range').attr('data-min', 70).attr('data-max', 120);
      minMaturityID = step.taffyObjects.y_aspects({
        display_name: 'Min Maturity'
      }).first().aspects_id;
      maxMaturityID = step.taffyObjects.y_aspects({
        display_name: 'Max Maturity'
      }).first().aspects_id;
      minMaturity = step.getInputEl({
        aspect: minMaturityID
      });
      maxMaturity = step.getInputEl({
        aspect: maxMaturityID
      });
      minMaturity.on('change', function() {
        var el;
        el = $(this);
        return setTimeout(function() {
          var valid;
          valid = !el.is('[class*="mfvalidate-invalid"]');
          return maxMaturity.attr('data-min', valid ? el.val() : 70);
        }, 0);
      });
      maxMaturity.on('change', function() {
        var el;
        el = $(this);
        return setTimeout(function() {
          var valid;
          valid = !el.is('[class*="mfvalidate-invalid"]');
          return minMaturity.attr('data-max', valid ? el.val() : 120);
        }, 0);
      });
      return true;
    };

    StepFunctions.prototype.addSoybeanMaturityValidation = function() {
      var maxMaturity, maxMaturityID, minMaturity, minMaturityID, step;
      step = this;
      minMaturityID = step.taffyObjects.y_aspects({
        aspect_name: 'Min Maturity'
      }).first().aspects_id;
      maxMaturityID = step.taffyObjects.y_aspects({
        aspect_name: 'Max Maturity'
      }).first().aspects_id;
      minMaturity = step.getInputEl({
        aspect: minMaturityID
      });
      maxMaturity = step.getInputEl({
        aspect: maxMaturityID
      });
      minMaturity.on('change', function() {
        var max, maxID, min, minID;
        minID = minMaturity.val();
        maxID = maxMaturity.val();
        if (minID) {
          if (!maxID) {
            return maxMaturity.val(minID).trigger('change');
          } else {
            min = step.taffyObjects.query_options({
              id: parseInt(minID)
            }).first();
            max = step.taffyObjects.query_options({
              id: parseInt(maxID)
            }).first();
            if (max.numeric_value < min.numeric_value) {
              return maxMaturity.val(minID).trigger('change');
            }
          }
        }
      });
      maxMaturity.on('change', function() {
        var max, maxID, min, minID;
        minID = minMaturity.val();
        maxID = maxMaturity.val();
        if (maxID) {
          if (!minID) {
            return minMaturity.val(maxID).trigger('change');
          } else {
            min = step.taffyObjects.query_options({
              id: parseInt(minID)
            }).first();
            max = step.taffyObjects.query_options({
              id: parseInt(maxID)
            }).first();
            if (min.numeric_value > max.numeric_value) {
              return minMaturity.val(maxID).trigger('change');
            }
          }
        }
      });
      return true;
    };

    StepFunctions.prototype.skipIfNoRootworm = function() {
      var arbitraryFieldID, step;
      step = this;
      arbitraryFieldID = step.parent.taffyObjects.fields({
        selected: true
      }).first().id;
      return !step.parent.getFieldAspectByName(arbitraryFieldID, 'Rootworm').value;
    };

    StepFunctions.prototype.skipIfAllIntegratedRefuge = function() {
      var all_integrated_refuge, selected_fields, step;
      step = this;
      all_integrated_refuge = true;
      selected_fields = step.parent.taffyObjects.fields({
        selected: true
      });
      selected_fields.each(function(field, i) {
        if (step.parent.getFieldAspectByName(field.id, 'Refuge-in-Bag').option_name !== 'Blended') {
          all_integrated_refuge = false;
          return false;
        }
      });
      return all_integrated_refuge;
    };

    return StepFunctions;

  })();

}).call(this);
